import { BalanceParams } from "../../../../balance/BalanceParams";
import { RequestConstants } from "../../../../core/request/RequestConstants";
import { WebRequest } from "../../../../core/request/WebRequest";
import { BalanceResponseData } from "../response/data/BalanceResponseData";
/**
 * BalanceRequest.ts
 */
export class BalanceRequest extends WebRequest {
    constructor(refresh = false) {
        super(BalanceRequest.URL, new BalanceParams(refresh));
    }
    getMethod() {
        return RequestConstants.POST;
    }
    getDataClass() {
        return BalanceResponseData;
    }
}
BalanceRequest.URL = "/gamecloud-servlets/api/account/gab";
//# sourceMappingURL=BalanceRequest.js.map